import { Pencil, Trash2 } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import type { HourType } from '@/types/hour-type'

interface CompanyHourTypesTabProps {
	hourTypes: HourType[]
	loading: boolean
	onCreate: () => void
	onEdit: (hourType: HourType) => void
	onDelete: (hourTypeId: string) => void
}

export function CompanyHourTypesTab({ hourTypes, loading, onCreate, onEdit, onDelete }: CompanyHourTypesTabProps) {
	return (
		<Card>
			<CardHeader>
				<div className="flex items-center justify-between">
					<CardTitle>Tipos de hora</CardTitle>
					<Button disabled={loading} onClick={onCreate}>
						Crear tipo de hora
					</Button>
				</div>
			</CardHeader>
			<CardContent>
				{loading ? (
					<div className="space-y-3">
						<Skeleton className="h-12 w-full" />
						<Skeleton className="h-12 w-full" />
					</div>
				) : (
					<Table>
						<TableHeader>
							<TableRow>
								<TableHead>Código</TableHead>
								<TableHead>Nombre</TableHead>
								<TableHead>Computable</TableHead>
								<TableHead className="w-24">Acciones</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{hourTypes.length === 0 ? (
								<TableRow>
									<TableCell colSpan={4} className="text-center text-muted-foreground">
										No hay tipos de hora
									</TableCell>
								</TableRow>
							) : (
								hourTypes.map((hourType) => (
									<TableRow key={hourType.id}>
										<TableCell>{hourType.code}</TableCell>
										<TableCell className="font-medium">{hourType.name}</TableCell>
										<TableCell>
											<Badge variant={hourType.computable ? 'default' : 'outline'}>
												{hourType.computable ? 'Sí' : 'No'}
											</Badge>
										</TableCell>
										<TableCell>
											<div className="flex gap-2">
												<Button variant="ghost" size="icon" onClick={() => onEdit(hourType)}>
													<Pencil className="h-4 w-4" />
												</Button>
												<Button
													variant="ghost"
													size="icon"
													onClick={() => onDelete(hourType.id)}
												>
													<Trash2 className="h-4 w-4 text-destructive" />
												</Button>
											</div>
										</TableCell>
									</TableRow>
								))
							)}
						</TableBody>
					</Table>
				)}
			</CardContent>
		</Card>
	)
}
